import { gqlClient } from '@/api/graphql-client';
import estimateKeys from '@/api/queries/estimates/keyFactory';
import { graphql } from '@/gql';
import {
  AddEstimateDefaultItemInput,
  AddEstimateDefaultItemMutation as AddEstimateDefaultItemMutationResult,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const AddEstimateDefaultItemMutation = graphql(`
  mutation AddEstimateDefaultItem($input: AddEstimateDefaultItemInput!) {
    addEstimateDefaultItem(input: $input) {
      id
      category
      quantity
      lineItem {
        id
      }
    }
  }
`);

const useAddEstimateDefaultItem = (
  options?: UseMutationOptions<
    AddEstimateDefaultItemMutationResult,
    Error,
    AddEstimateDefaultItemInput
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(AddEstimateDefaultItemMutation, { input });
    },
    onSettled: (_data, _error, variables) => {
      void queryClient.invalidateQueries({
        queryKey: estimateKeys.estimateDefaultItems(variables.category),
      });
    },
    ...options,
  });
};

export default useAddEstimateDefaultItem;
